<div>
  <div *ngFor="let day of closedTimes; let dayIndex = index; trackBy: trackById">
    <h3>{{ day.name | titlecase }}</h3>
    <div *ngFor="let group of day.times.controls; let i = index; trackBy: trackById">
      <div class="times-line" [class.error]="group.invalid">
        <div class="date-picker">
          <span>Closes At</span>
          <ngx-timepicker-field
            [formControl]="day.times.controls[i].get('closeValueString')"
            [format]="24"
          ></ngx-timepicker-field>
        </div>
        <div class="date-picker">
          <span>Opens At</span>
          <ngx-timepicker-field
            [formControl]="day.times.controls[i].get('openValueString')"
            [format]="24"
          ></ngx-timepicker-field>
        </div>
        <mat-icon class="icon-button" (click)="removeLine(dayIndex, i)">remove_circle</mat-icon>
      </div>
      <mat-error *ngIf="group.invalid">Close time must be before open time</mat-error>
    </div>
    <div class="add-icon">
      <mat-icon (click)="addLine(dayIndex)" class="icon-button">add_circle</mat-icon>
    </div>
  </div>
  <button mat-raised-button class="submit" color="primary" (click)="saveChanges()">
    Save Non-Operational Hours
  </button>
</div>
